<template>
    <div>
        <div class="row">
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="examType"><span class="required">*</span>{{ $t("labels.archiveCategory") }}</label>
                            <select class="form-control" v-model="typeId">
                                <option v-for="tp in archiveCategories" :value="tp._id" :key="tp._id">{{ tp.name[$i18n.locale] ? tp.name[$i18n.locale] : tp.name['en'] }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="archiveDate"><span class="required">*</span>{{ $t("labels.archiveDate") }}</label>
                            <date-picker v-model="archive.date"  :lang="$i18n.locale" width="100%" type="datetime" appendToBody format="DD/MM/YYYY"  ></date-picker>
                        </div>
                    </div>
                </div>
                 <button type="button" class="btn btn-success" @click.prevent="createArchive">
                    <i class="icon-note"></i> {{ this.$t("labels.save") }}
                </button>
            </div>
            <div class="col-md-6">
                <div class="dropzone bottom-space">
                    <h5>
                        * {{ $t("labels.archiveUpload") }}
                        <span><strong>{{ $t('labels.maxVideoSize') }}:</strong><br>15 Mb</span>
                        <span><strong>{{ $t('labels.allowedFormats') }}:</strong><br>{{ $store.state.allowedFileTypesSimple.toString().split(',').join(', ') }}</span>
                    </h5> <br>
                    <input type="file" id="file" ref="file" @change="getFile">
                </div>
                <div class="row" v-if="archive.file.name">
                    <div class="col-md-10">
                        <span><strong>{{ $t('labels.name') }}:</strong> {{ archive.file.name }}</span> <br />
                        <span :class="{red: archive.file.size/1024/1024 > 15}"><strong>{{ $t('labels.size') }}:</strong> {{ Math.round(archive.file.size/1024/1024) }} Mb</span> <br />
                        <span :class="{red: !$store.state.allowedFileTypes.includes(archive.file.type)}"><strong>{{ $t('labels.type') }}:</strong> {{ archive.file.type }}</span>
                    </div>
                    <div class="col-md-2">
                        <a class="warning p-0" @click.prevent="deleteFile"><i class="fa fa-trash font-medium-3 mr-2"></i></a>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
          <div class="col-md-6">
              <div class="form-group">
                  <label for="entryFilter">{{ $t("labels.archiveCategoryFilter") }}</label>
                  <select class="form-control" v-model="selectedCategory">
                      <option :value="null">{{ $t("labels.archiveCategory") }}</option>
                      <option v-for="(category, index) in archiveCategories" :key="index" :value="category._id">
                        {{ category.name[$i18n.locale]}}
                      </option>
                  </select>
              </div>
          </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <table class="table table-responsive-sm">
                    <thead>
                        <th>
                            {{ $t("labels.archiveCategory") }}
                        </th>
                        <th>
                            {{ $t("labels.type") }}
                        </th>
                        <th>
                            {{ $t("labels.name") }}
                        </th>
                        <th>
                            {{ $t("labels.archiveDate") }}
                        </th>
                        <th>
                            {{ $t("labels.actions") }}
                        </th>
                    </thead>
                    <tbody>
                        <tr v-for="archive in archives" :key="archive._id">
                            <td>
                                {{ archive.category.name[$i18n.locale] ? archive.category.name[$i18n.locale] : archive.category.name['en'] }}
                            </td>
                            <td>
                                {{ archive.file.mimetype }}
                            </td>
                            <td>
                                {{ archive.file.originalname }}
                            </td>
                            <td>
                                {{ formatDate(archive.date) }}
                            </td>
                            <td>
                                <a :href="archive.file ? archive.file.signed_url : ''" download><i class="fa fa-download font-medium-3 mr-2"></i></a>
                                <a href="#" @click.prevent="deleteArchive(archive)"><i class="fa fa-trash font-medium-3 mr-2"></i></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import ArchivesService from '@/services/archive'
import LovService from '@/services/lov'
import Progress from './Progress'
import moment from 'moment'

export default {
    props: ["patient"],
    components: {
        Progress
    },
    data() {
        return {
            errors: [],
            typeId: '',
            archiveCategories: [],
            selectedCategory: null,
            archive: {
                patientId: null,
                file: {},
                date: moment(new Date()).format('YYYY-MM-DD')
            },
            archives: []
        }
    },
    computed: {
        archiveCategory() {
            let result = this.archiveCategories.find(t => t._id === this.typeId)
            let tpval = {
                id: result._id,
                type: result.type,
                name: result.name
            }
            return tpval
        }
    },
    methods: {
        getFile() {
            if (this.$refs.file.files.length > 0) {
                this.archive.file = this.$refs.file.files[0]
            }
        },
        deleteFile() {
            this.$refs.file.value = ''
            this.archive.file = {}
        },
        getArchives: async function () {
            let result = await ArchivesService.all(this.patient._id, this.selectedCategory)
            if (result) {
                this.archives = result.data
            }
        },
        createArchive: async function () {
            let loader = this.$loading.show({
                color: '#ccc',
                loader: 'spinner'
            },{
                after: this.$createElement('Progress')
            })
            this.errors = []
            if (!this.archive.date) {
                this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.archiveDate")]))
            }
            if (!this.typeId || this.typeId.length === 0) {
                this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.archiveCategory")]))
            }
            if (this.archive.file) {
                if (!this.$store.state.allowedFileTypes.includes(this.archive.file.type)) {
                    this.errors.push(this.$t("errors.wrongFiletype", [this.archive.file.name]))
                }
                let fileSizeMb = this.archive.file.size/1024/1024
                if (fileSizeMb > 15) {
                    this.errors.push(this.$t("errors.tooLarge", [this.archive.file.name]))
                }
            }
            if (this.errors.length === 0) {
                this.archive.category = this.archiveCategory
                let formData = new FormData()
                formData.append('file', this.archive.file)
                formData.append('archive', JSON.stringify(this.archive))
                let result = await ArchivesService.create(formData)
                if (result.data.success) {
                    this.getArchives()
                    this.archive = {
                        patientId: this.patient._id,
                        file: {},
                        date: moment(new Date()).format('YYYY-MM-DD')
                    }
                    this.$miniToastr.success(this.$t("flashes.createSuccess", ["Archive"]))
                } else {
                    if (result.data.errors) {
                        for (let err in result.data.errors) {
                            this.errors.push(result.data.errors[err])
                        }
                    } else {
                        this.errors.push(result.data.msg)
                    }
                    this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
                }
            } else {
                this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
            }
            loader.hide()
            this.$store.state.currentProgress = 0
        },
        deleteArchive: async function (archive) {
            let result = await ArchivesService.delete(archive)
            if (result.data.success) {
                this.getArchives()
                this.$miniToastr.success(this.$t("flashes.deleteSuccess", ["Archive"]))
            } else {
                this.$miniToastr.error(this.$t("flashes.deleteFailed", ["Archive"]))
            }
        },
        formatDate(date) {
            return moment(new Date(date)).format('DD/MM/YYYY')
        }
    },
    watch: {
      selectedCategory: function(_) {
        this.getArchives()
      }
    },
    mounted: async function() {
        await this.getArchives()
        let archiveCategories = await LovService.all('archive_category', false)
        if (archiveCategories) {
            this.archiveCategories = archiveCategories.data
        }
        this.archive.patientId = this.patient._id
        let that = this
        this.$on('filter-by', function(categoryId){
          that.selectedCategory = categoryId
        })
    }
}
</script>

<style lang="scss">
    .dropzone {
        width: 100%;
        background-color: #eee;
        display: flex;
        position: relative;
        align-items: center;
        justify-content: center;
        min-height: 120px;
        outline: 2px dashed #eee;
        outline-offset: 5px;
        border: none;
        transition: all .5s ease;

        h5 {
            padding: 15px;
            text-align: center;
            max-width: 90%;

            span {
                margin-top: 15px;
                display: block;
                font-size: 12px;

                strong {
                text-transform: uppercase;
                }
            }
        }

        &:hover {
            background-color: darken(#eee,10%);
            outline: 2px dashed darken(#eee,10%)
        }

        input {
            position: absolute;
            left: 0;
            top: 0;
            opacity: 0;
            width: 100%;
            height: 100%;
            cursor: pointer;
        }
    }
</style>


